var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: { variant: "primary", size: "sm" },
              on: { click: _vm.addMeta }
            },
            [
              _c("i", { staticClass: "fa fa-tasks" }),
              _vm._v(" Visualizar Metas")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "mr-2",
              attrs: {
                variant: "primary",
                size: "sm",
                href: "/adm/bonificacao"
              }
            },
            [
              _c("i", { staticClass: "fas fa-arrow-alt-circle-right" }),
              _vm._v(" Pedidos Bonificados")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "mt-3" }, [
        _vm._v("Indicadores - Pedidos Bonificados")
      ]),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "mb-0",
                  attrs: { "label-for": "filter-input", "label-size": "sm" }
                },
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: {
                          size: "sm",
                          id: "filter-input",
                          type: "search",
                          placeholder: "Buscar Distribuidor"
                        },
                        model: {
                          value: _vm.filter,
                          callback: function($$v) {
                            _vm.filter = $$v
                          },
                          expression: "filter"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", disabled: !_vm.filter },
                              on: {
                                click: function($event) {
                                  _vm.filter = ""
                                }
                              }
                            },
                            [_vm._v("Limpar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            staticClass: "mt-1",
            attrs: {
              items: _vm.listpedidos,
              fields: _vm.fields,
              "show-empty": "",
              hover: "",
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              filter: _vm.filter,
              "filter-included-fields": _vm.filterOn,
              "sort-direction": _vm.sortDirection,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc
            },
            on: {
              filtered: _vm.onFiltered,
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              }
            }
          }),
          _vm._v(" "),
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "fill",
              size: "sm"
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e5aaf05e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5aaf05e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_metas/Metas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e5aaf05e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_metas/Metas.vue
// module chunks = 2